import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import { ModalController } from '@ionic/angular';
import {ApiService} from "../service/api.service";

@Component({
  selector: 'app-online-list',
  templateUrl: './online-list.component.html',
  styleUrls: ['./online-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OnlineListComponent implements OnInit, OnDestroy {

  onlineList = [];

  constructor(
    public modalCtr: ModalController,
    public apiService: ApiService
  ){
    this.getOnlineList();
  }

  ngOnInit() {}

  ngOnDestroy(): void {}

  async closeModal() {
    await this.modalCtr.dismiss();
  }

  getOnlineList() {
    this.apiService.getOnlineList().subscribe(
      res => {
        this.onlineList = JSON.parse(res);
      });
  }
}
